export default "https://cdn-static.gokick.com/assets/528ec2ebd6131ff545f204827e0544e2c800444b/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";